module.exports = __webpack_public_path__ + "img/otrosrecursos2.1b6ec050.png";